export const FLOW_DATE_FORMAT = 'DD/MM/YYYY';
export const FLOW_DATE_FULL_FORMAT_ABBR = 'ddd D MMMM Y';
export const FLOW_DATE_FULL_FORMAT = 'dddd D MMMM Y';
export const FLOW_TIME_FORMAT = 'HH:mm';

export const PAYMETHOD_CREDIT_CARD_ID = "7";
export const PAYMETHOD_POINTS_ID = "9";
export const PAYMETHOD_CREDIT_CARD_ICON = 'card-outline';
export const PAYMETHOD_POINTS_ICON = 'pricetag-outline';
